import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class MessaginggalleryController {
  constructor(
    $http,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    SecurityService,
    $rootScope,
    $scope,
    $localStorage,
    ngProgressFactory,
    $timeout,
    $location
  ) {
    this.name = "messaginggallery";
    this.$http = $http;
    this.$auth = AuthService;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$progress = ngProgressFactory.createInstance();
    this.$events = EventsService;
    this.$localStorage = $localStorage;
    this.$security = SecurityService;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 0;

    this.isLazyUser = true;
    this.errorMessage = {status: false, message: null};
    this.newUserObj = {email: null, password: null, password2: null};
    this.showContinueButton = false;
    this.check_policy = false;
    this.displayTOSModal = false;
    var _this = this;

    _this.CollectPhotosListener = _this.$rootScope.$on("CollectPhotos", function ($event, params) {
      console.log("does this get called?");
      console.dir(params);
      if (params.dataprof) {
        _this.mainPhotoUrl = params.dataprof[0];
        _this.photos = params.dataprof;
        _this.isProfilePage = true;
      } else {
        _this.mainPhotoUrl = params.data.imageURL;
      }
    });

    _this.$scope.$on("$destroy", _this.CollectPhotosListener);
    _this.$timeout(function () {
      jQuery("#messaging-gallery").focus();
    }, 300);
  }

  next(data) {
    if (this.isProfilePage) {
      for (var i = 0; i < this.photos.length; i++) {
        if (this.photos[i] === this.mainPhotoUrl) {
          var next = i + 1;
          if (next === this.photos.length) {
            next = 0;
          }
          this.mainPhotoUrl = this.photos[next];
          break;
        }
      }
    } else {
      for (var i = 0; i < this.$rootScope.photos.length; i++) {
        if (this.$rootScope.photos[i] === this.mainPhotoUrl) {
          var next = i + 1;
          if (next === this.$rootScope.photos.length) {
            next = 0;
          }
          this.mainPhotoUrl = this.$rootScope.photos[next];
          break;
        }
      }
    }
  }

  previous(data) {
    if (this.isProfilePage) {
      for (var i = 0; i < this.photos.length; i++) {
        if (this.photos[i] === this.mainPhotoUrl) {
          if (i === 0) {
            next = this.photos.length - 1;
          } else {
            var next = i - 1;
          }

          this.mainPhotoUrl = this.photos[next];
          break;
        }
      }
    } else {
      for (var i = 0; i < this.$rootScope.photos.length; i++) {
        if (this.$rootScope.photos[i] === this.mainPhotoUrl) {
          if (i === 0) {
            next = this.$rootScope.photos.length - 1;
          } else {
            var next = i - 1;
          }

          this.mainPhotoUrl = this.$rootScope.photos[next];
          break;
        }
      }
    }
  }

  closeGallery() {}

  close() {
    var _this = this;
    if (_this.$location.$$path.indexOf("review") > -1 || _this.$location.$$path.indexOf("overview") > -1) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("CloseGalleryReview", {});
      });
    } else {
      _this.$timeout(function () {
        _this.$rootScope.$emit("CloseGallery", {});
      });
    }
  }

  key($event) {
    var _this = this;

    console.log($event.keyCode);

    if ($event.keyCode == 39) {
      _this.next(_this.mainPhotoUrl);
    }
    if ($event.keyCode == 37) {
      _this.previous(_this.mainPhotoUrl);
    }
  }
}

MessaginggalleryController.$inject = [
  "$http",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "security",
  "$rootScope",
  "$scope",
  "$localStorage",
  "ngProgressFactory",
  "$timeout",
  "$location",
];

export default MessaginggalleryController;



// WEBPACK FOOTER //
// ./client/app/common/messaginggallery/messaginggallery.controller.js